<p-blockUI [target]="pnl" [blocked]="blocked">
    <i class="pi pi-lock" style="font-size: 4rem"></i>
</p-blockUI>

<p-fieldset  #pnl>
    <ng-template pTemplate="header">{{lbl_future_guide}} ({{lbl_summary}})</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" (click)="goBackClose()"></button>
        </ng-template>

    </p-toolbar>

    <div class="card">
        <div class="p-grid">
    
            <div class="p-col-12 p-md-6">
                <div class="card">
                    <div class="p-fluid">
                        <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                            
                            <label for="opt">{{lbl_period}}</label>
                            <div class="p-col-6 p-md-10">
                                <p-dropdown   [options]="listPeriods" [(ngModel)]="selectedPeriod"  optionLabel="descrip" [showClear]="true" placeholder="{{lbl_select}} {{lbl_period}}" ></p-dropdown>
                            </div>
                        </div>
                        <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                            <div class="p-mr-2 p-mb-2">
                                <p-button label="{{lbl_search}}"  icon="pi pi-search" (onClick)="search()" loading="loadingSearch"></p-button>
                            </div>
                        </div>
                        
                    
                    </div>
                </div>

            </div>
            <div class="col-12 lg:col-6">
                <p-toast></p-toast>
                <div class="card ">
                    <div class="grid p-fluid">
                        <div class="col-66 lg:col-6">
                            <div class="card height-100">
                                <p-table #dt1 [value]="listStatisticsZones"  [rows]="15" [paginator]="true" [globalFilterFields]="['TipoReporte.P_REPORT_NAME','executionReport.estatus.EXECUTION_DESCR']"
                                        [(selection)]="selectedStatistic" [rowHover]="true" dataKey="id" [filterDelay]="0"
                                        styleClass="p-datatable-customers"
                                        currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}" [showCurrentPageReport]="true">
                                        <ng-template pTemplate="caption">
                                            <div class="p-d-flex p-ai-center p-jc-between">
                                                <h5 class="p-m-0">{{lbl_participants}}  </h5>
                                                <span class="p-input-icon-left">
                                                    <i class="pi pi-search"></i>
                                                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="{{lbl_search}}..." />
                                                </span>
                                            </div>
                                            
                                            <span class="p-input-icon-left">
                                                
                                                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                                                
                                            </span>
                                        </ng-template>
                                    <ng-template pTemplate="header">
                                        <tr>
                                            <th pSortableColumn="TipoReporte.P_REPORT_NAME">{{lbl_coordination}}<p-sortIcon field="TipoReporte.P_REPORT_NAME"></p-sortIcon></th>
                                            <th pSortableColumn="executionReport.REPORT_DATE_SEND">{{lbl_total}}<p-sortIcon field="executionReport.REPORT_DATE_SEND"></p-sortIcon></th>
                                            <th>{{lbl_select}}</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-statistic>
                                        <tr>
                                            <td><span class="p-column-title"></span>
                                                {{statistic.description}}
                                            </td>
                                            <td><span class="p-column-title"></span>
                                                {{statistic.total}}
                                            </td>
                                            <td>
                                                <button type="button" pButton pRipple icon="pi pi-search"
                                                (click)="selectRecord(statistic.id)"></button>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="summary">
                                        <div class="flex align-items-center justify-content-between">
                                            {{lbl_total}}  {{listStatisticsZones ? listStatisticsZones.length : 0 }} {{lbl_coordinations}}.
                                        </div>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>  
                        
                        <div class="col-12 lg:col-6" *ngIf="listStatisticsZones != null && listStatisticsZones.length > 0">
                            <div class="card height-100">
                                    
                                    <p-chart type="bar" [data]="data" [options]="chartOptions" ></p-chart>
                            </div>
                        </div>
                            
                        
                    </div>
                </div>
        
        
                <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
            </div>
        </div>
    </div>

</p-fieldset>

